module.exports = __webpack_public_path__ + "static/media/oberflex-frenefr101-2560x1440.a29f2f5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frenefr101-2560x1440.jpg
// module id = 1021
// module chunks = 37